import { render, staticRenderFns } from "./jianyi.vue?vue&type=template&id=aff5443c&scoped=true&"
import script from "./jianyi.vue?vue&type=script&lang=ts&"
export * from "./jianyi.vue?vue&type=script&lang=ts&"
import style0 from "./jianyi.vue?vue&type=style&index=0&id=aff5443c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff5443c",
  null
  
)

export default component.exports